<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 09:51:16
 * @LastEditTime: 2020-06-21 16:38:49
 * @Description: 单选题
 -->
<template>
  <div class="single">
    <div class="title">
      <span>{{ title }}</span>
      <div
        v-if="stemMediaInfoVO.mediaPath"
        class="look-media"
        @click="lookMedia(stemMediaInfoVO)">查看多媒体</div>
    </div>
    <i-radio-group :vertical="true" size="small" :value="value">
      <i-radio
        v-for="(option, index) in options"
        :key="index"
        :label="option.id" disabled>
        <span
          class="option-content">
          {{ `${optionsMap[index]}、${option.content ? option.content : ''}` }}</span>
        <div
          v-if="option.mediaInfoVO && option.mediaInfoVO.mediaPath"
          class="look-media"
          @click="lookMedia(option.mediaInfoVO)">查看多媒体</div>
      </i-radio>
    </i-radio-group>
    <div class="analysis">
      <div class="analysis-left">
        <p>学员答案：{{ userAnswer }}</p>
        <p>正确答案：{{ correctAnswer }}</p>
        <p>解析说明：{{ tip !== undefined ? tip : '无' }}</p>
      </div>
      <div class="analysis-right" v-if="status === '已统分'">
        <div :class="[correct ? 'correct' : 'error']">
          {{ correct ? '正确' : '错误' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const optionsMap = ['A', 'B', 'C', 'D', 'E', 'F'];

export default {
  name: 'SingleChoice',
  props: {
    status: { type: String, required: true },
    index: { type: Number, required: true },
    question: { type: Object, required: true },
  },
  data() {
    return {
      value: '',
      optionsMap,
      userAnswer: '',
      correctAnswer: '',
    };
  },
  computed: {
    title() {
      return `${this.index + 1}、${this.question.content}（${this.question.totalScore}分）`;
    },
    options() {
      return this.question.options;
    },
    correct() {
      return this.question.correct;
    },
    counted() {
      return this.correct !== undefined;
    },
    tip() {
      return this.question.tip;
    },
    stemMediaInfoVO() {
      return this.question.mediaInfoVO ? this.question.mediaInfoVO : {};
    },
  },
  watch: {
    question: {
      immediate: true,
      handler({ userAnswer, options }) {
        if (!(options instanceof Array)) {
          options = [];
        }

        options.forEach((option, index) => {
          if (userAnswer === option.id) {
            this.userAnswer = this.optionsMap[index];
            this.value = option.id;
            // eslint-disable-next-line no-useless-return
            return;
          }
        });
      },
    },
    options: {
      immediate: true,
      handler(options) {
        if (!(options instanceof Array)) {
          options = [];
        }

        options.forEach((option, index) => {
          if (option.correct) {
            this.correctAnswer = this.optionsMap[index];
            // eslint-disable-next-line no-useless-return
            return;
          }
        });
      },
    },
  },
  methods: {
    lookMedia({ mediaContentType, mediaPath, videoCover }) {
      this.$emit('preview-media', { mediaContentType, mediaPath, videoCover });
    },
  },
};
</script>

<style lang="less" scoped>
.single {
  width: 100%;

  > .title {
    margin-bottom: 8px;
  }

  /deep/ .ivu-radio-group {
    .ivu-radio-wrapper {
      font-size: 12px;

      .ivu-radio {
        margin-right: 8px;
      }

      .ivu-radio-disabled .ivu-radio-inner:after {
        background-color: #2d8cf0;
      }
    }
  }

  > .analysis {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    padding: 6px 10px;
    background-color: #fbf9fb;

    > .analysis-left {
      > p {
        line-height: 26px;
      }
    }

    > .analysis-right {
      display: flex;
      align-items: center;

      >.error{
        width: 42px;
        height: 24px;
        font-size: 13px;
        color: #fff;
        line-height: 24px;
        text-align: center;
        background-color: #ed4014;
      }

      >.correct{
        width: 42px;
        height: 24px;
        font-size: 13px;
        color: #fff;
        line-height: 24px;
        text-align: center;
        background-color: #2d8cf0;
      }
    }
  }

  .option-content {
    margin-right: 16px;
  }

  .look-media {
    display: inline-block;
    color: #0C8CCA;
    font-size: 12px;
    cursor: pointer;
    padding: 4px 8px;
    background-color: rgba(12, 140, 202, .1);
    border-radius: 6px;
    line-height: normal;
  }
}
</style>
